<template>
  <v-app>
    <v-container class="d-flex flex-column align-center justify-center" style="min-height: 100vh">
      <div class="text-center">
        <h1 class="display-1 mb-4">403</h1>
        <h2 class="headline mb-6">권한이 없습니다</h2>
        <p class="body-1 mb-8 grey--text">
          요청하신 페이지에 접근할 권한이 없습니다.
        </p>
        <div class="d-flex flex-column flex-sm-row gap-4 justify-center">
          <v-btn
            color="primary"
            class="rounded-10"
            depressed
            large
            @click="$router.push('/')"
          >
            홈으로 이동
          </v-btn>
          <v-btn
            v-if="isAdminPath"
            color="secondary"
            class="rounded-10"
            outlined
            large
            @click="$router.push('/admin/auth/login')"
          >
            관리자 로그인
          </v-btn>
        </div>
      </div>
    </v-container>
  </v-app>
</template>

<script>
export default {
  name: "Error403",
  computed: {
    isAdminPath() {
      return this.$route.path.startsWith("/admin")
    },
  },
  mounted() {
    document.title = "권한 없음 - 라피아 공주의 성"
  },
}
</script>

<style scoped>
.gap-4 {
  gap: 16px;
}
</style>

